import React from "react";
import ServiceDetailLayout from "./ServiceDetailLayout";

export default function CloudDetail() {
	return (
		<ServiceDetailLayout
			title="Cloud & Hébergement"
			summarySections={[
				{ id: "intro", label: "Introduction" },
				{ id: "pourquoi", label: "Pourquoi le cloud ?" },
				{ id: "avantages", label: "Bénéfices pour votre activité" },
				{ id: "solutions", label: "Solutions proposées" },
				{ id: "securite", label: "Sécurité & conformité" },
				{ id: "accompagnement", label: "Accompagnement & support" },
				{ id: "process", label: "Notre Processus" },
				{ id: "faq", label: "FAQ" }
			]}
		>
			<section id="intro">
				<h2>Introduction</h2>
				<p>
					Nos experts cloud vous accompagnent dans la migration, l’optimisation et la sécurisation de vos infrastructures informatiques. Nous proposons des solutions d’hébergement sur-mesure, adaptées à vos enjeux de performance, de scalabilité et de conformité réglementaire. Notre approche s’appuie sur les technologies les plus récentes (cloud public, privé, hybride) et une expertise reconnue en architecture, DevOps et cybersécurité.
				</p>
			</section>
			<section id="pourquoi">
				<h2>Pourquoi le cloud&nbsp;?</h2>
				<p>
					Le cloud permet de gagner en agilité, de réduire les coûts d’exploitation et d’accélérer la transformation digitale de votre organisation. Il offre une flexibilité inégalée pour adapter vos ressources à la demande, garantir la continuité d’activité et faciliter l’innovation. Nos solutions cloud sont conçues pour répondre aux exigences des PME, ETI et grands comptes, avec un accompagnement personnalisé à chaque étape du projet.
				</p>
			</section>
			<section id="avantages">
				<h2>Bénéfices pour votre activité</h2>
				<p>
					• Réduction des coûts d’infrastructure et de maintenance<br />
					• Accès sécurisé à vos données et applications depuis n’importe où<br />
					• Scalabilité instantanée pour accompagner votre croissance<br />
					• Haute disponibilité et reprise d’activité automatisée<br />
					• Conformité RGPD et certifications ISO, HDS, PCI-DSS
				</p>
			</section>
			<section id="solutions">
				<h2>Solutions proposées</h2>
				<p>
					Nous déployons des architectures cloud sur-mesure :<br />
					• Hébergement web, bases de données, serveurs applicatifs<br />
					• Conteneurisation (Docker, Kubernetes) et automatisation DevOps<br />
					• Sauvegarde, archivage et plan de reprise d’activité<br />
					• Monitoring, alerting et optimisation des performances<br />
					• Interconnexion avec vos systèmes existants (VPN, API, SSO)<br />
					Chaque solution est dimensionnée selon vos besoins métiers et vos contraintes réglementaires.
				</p>
			</section>
			<section id="securite">
				<h2>Sécurité & conformité</h2>
				<p>
					La sécurité de vos données est notre priorité : chiffrement, gestion des accès, audits réguliers, conformité RGPD et certifications sectorielles. Nous assurons une surveillance proactive 24/7, des tests d’intrusion et une veille technologique permanente pour anticiper les menaces et garantir la résilience de vos infrastructures.
				</p>
			</section>
			<section id="accompagnement">
				<h2>Accompagnement & support</h2>
				<p>
					Un chef de projet dédié vous accompagne dans la définition de votre stratégie cloud, la migration de vos applications et la formation de vos équipes. Notre support technique est disponible en continu, avec des engagements de service (SLA) adaptés à vos enjeux critiques et une assistance personnalisée pour chaque incident ou évolution.
				</p>
			</section>
			<section id="process">
				<h2>Notre Processus</h2>
				<ol>
					<li>Audit de l’existant et définition des objectifs</li>
					<li>Conception d’architecture et choix des solutions</li>
					<li>Mise en œuvre, migration et tests de performance</li>
					<li>Déploiement, monitoring et optimisation continue</li>
					<li>Formation, documentation et transfert de compétences</li>
				</ol>
			</section>
			<section id="faq">
				<h2>FAQ</h2>
				<p>
					Besoin d’un conseil sur la migration vers le cloud, la sécurisation de vos données ou l’optimisation de vos coûts&nbsp;? Nos consultants sont à votre écoute pour vous apporter des réponses concrètes et des solutions adaptées à votre secteur d’activité.
				</p>
			</section>
		</ServiceDetailLayout>
	);
}
